import React from 'react';
import CardProject from '../../../../../components/Molecules/Cards/Project/CardProject';

const ProjectsDone = ({ projects }) => {
	return (
		<div className={"projects-done"}>
			<h3 className={"color-primary"}>Projets terminés</h3>
			<div className={"section-home-architect__wrapper"}>
				{projects.map((project, index) => {
					return (
						<CardProject
							key={index}
							id={project.id}
							project={project}
						/>
					)
				}
				)}
			</div>
		</div>
	);
};
export default ProjectsDone;
